import { FC } from 'react';
import { Stack } from '@mui/material';
import { useFormikContext } from 'formik';
import { InputCheck, InputText, InputTextArea } from '@farmshare/ui-components';
import { Extra } from '../../types';

interface ExtrasSelectionFormValues {
  required?: boolean;
  minSelections?: number;
}

interface ExtrasSelectionQuestionFormProps {
  extras?: Extra[];
  /** The capability set ID used to group uploaded images in S3. */
  capabilityId: string;
}

/**
 * Form for creating/editing Extras Selection questions. Mirrors
 * FreeSelectionQuestionForm but scoped to extras.
 * @param root0
 * @param root0.extras
 * @param root0.capabilityId
 */
export const ExtrasSelectionQuestionForm: FC<
  ExtrasSelectionQuestionFormProps
> = ({ extras = [], capabilityId }) => {
  const { values } = useFormikContext<ExtrasSelectionFormValues>();
  // extras is passed for future UX (e.g., listing picked items) but not
  // rendered as a select here — the user drops catalog extras into the
  // question card instead, same pattern as FreeSelection.
  void extras;

  return (
    <Stack spacing={3}>
      <InputText label="Question Title" nameOverride="title" required />
      <InputTextArea
        label="Description"
        nameOverride="description"
        rows={2}
        hint="Optional description to help customers understand their options"
      />

      <InputCheck label="Required" nameOverride="required" />

      {values.required && (
        <Stack direction="row" spacing={2}>
          <InputText
            label="Minimum Selections"
            nameOverride="minSelections"
            type="number"
            hint="Minimum number of extras the customer must select"
          />

          <InputText
            label="Maximum Selections"
            nameOverride="maxSelections"
            type="number"
            hint="Leave empty for unlimited"
          />
        </Stack>
      )}
    </Stack>
  );
};
